import React, { useMemo } from 'react';
import { useAuth } from '../../DataStore/AuthContext';

const VoucherCardView = ({
  data,
  brandTitle = 'OPENFI VOUCHER',
  wifiName = 'OPENFI PUBLIC WIFI',
  loginUrl = 'http://10.0.0.1',
  ref
}) => {
  const { connectedProfiles } = useAuth();
  const rows = Array.isArray(data) ? data : [];

  // ===== Layout controls =====
const GRID_COLS = 6;     // was 5
const GRID_ROWS = 8;     // new
const PER_PAGE  = GRID_COLS * GRID_ROWS; // 48 per page
// ===========================

  const pages = useMemo(() => {
    const chunk = [];
    for (let i = 0; i < rows.length; i += PER_PAGE) {
      chunk.push(rows.slice(i, i + PER_PAGE));
    }
    return chunk.length ? chunk : [[]];
  }, [rows]);

  const formatPrice = (r) =>
    r?.amount
      ? `${r.currency || connectedProfiles?.currency || 'UGX'} ${new Intl.NumberFormat().format(r.amount)}`
      : '';

  const formatDuration = (secs) => {
    const s = Number(secs || 0);
    if (!s) return '';
    const h = Math.floor(s / 3600);
    const m = Math.round((s % 3600) / 60);
    if (h && m) return `${h}hr ${m}min`;
    if (h) return `${h}hr${h > 1 ? 's' : ''}`;
    return `${m}min`;
  };

  const codeOf = (r) => r.code || r.voucher_code || '';

  return (
    <div
      className="table-responsive"
      style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 650 }}
      ref={ref}
    >
   

   <style>{`
  @page { size: A4; margin: 4mm; } /* try to reduce printer margins */

  @media print {
    .no-print { display: none !important; }
    .table-responsive { overflow: visible !important; max-height: none !important; }
  }

  .a4-page {
    width: 210mm;
    min-height: 297mm;
    padding: 4mm;               /* was 8mm */
    margin: 0 auto;
    background: #fff;
    box-sizing: border-box;
    page-break-after: always;
  }

  @media screen {
    .a4-page { box-shadow: 0 0 0 1px rgba(0,0,0,.08), 0 6px 18px rgba(0,0,0,.06); }
  }

  /* grid that fits 6 x 8 on A4 */
  .voucher-grid {
    display: grid;
    grid-template-columns: repeat(${GRID_COLS}, 1fr);
    grid-auto-rows: 33mm;       /* fixed row height to guarantee 8 rows fit */
    gap: 2mm;                   /* was 4mm */
  }

  .voucher-card {
    border: 1px dashed #d9534f; /* thinner */
    border-radius: 2px;
    padding: 2.5mm 2mm;         /* was 5mm 4mm */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;           /* keeps text inside */
  }

  .brand-banner {
    background: #0d1b2a;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    letter-spacing: .3px;
    border-radius: 2px;
    margin-bottom: 1.5mm;       /* tighter */
    text-transform: uppercase;
    font-size: 8px;             /* smaller */
    padding: 1mm 1mm;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .voucher-headline {
    text-align: center;
    margin: 0 0 1mm;
    font-weight: 900;
    font-size: 8.5px;           /* smaller */
    color: #000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .voucher-code {
    text-align: center;
    font-weight: 900;
    font-size: 10.5px;          /* still readable */
    letter-spacing: .4px;
    margin-bottom: 1mm;
    color: #000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .meta {
    display: flex;
    justify-content: center;    /* tighter than space-between */
    align-items: center;
    font-size: 8px;
    margin-top: 1mm;
  }

  .muted {
    color: #6c757d;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    text-align: center;
  }
`}</style>



      {/* Pages */}
      {pages.map((pageRows, pIdx) => (
        <div className="a4-page" key={`page-${pIdx}`}>
          <div className="voucher-grid">

            {pageRows.map((r) => (
              <div key={r.id ?? codeOf(r)} className="voucher-card">
                <div>
                  <div className="brand-banner">{r.ssid}</div>

                  {/* Headline (Price + Duration) */}
                  <h4 className="voucher-headline">
                    {formatPrice(r) ? `${formatPrice(r)}` : r.plan_name || 'WIFI PLAN'}
                  </h4>
                  <div className="voucher-code">
                    {formatDuration(r?.allowed_seconds)
                      ? `${formatDuration(r.allowed_seconds)} : ${codeOf(r)}`
                      : codeOf(r)}
                  </div>

                </div>

                {/* Footer meta */}
                <div className="meta">
                  <span className="muted">{r.plan_name || '—'}</span>
                  {/* <span className="muted">{codeOf(r)}</span> */}
                </div>
              </div>
            ))}

            {/* Fill blanks to keep grid tight if last page isn’t full */}
            {pageRows.length < PER_PAGE &&
              Array.from({ length: PER_PAGE - pageRows.length }).map((_, i) => (
                <div key={`blank-${i}`} className="voucher-card" />
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VoucherCardView;
